import SyosUiContainer from './SyosUiContainer';
import SyosEvents from './utils/SyosEvents';
import SyosBtnViewKeyCommands from './SyosBtnViewKeyCommands';
import SyosBtnViewScreens from './SyosBtnViewScreens';
import SyosFullscreenManager from './utils/SyosFullscreenManager';
import SyosBtnToggleFullScreen from './SyosBtnToggleFullScreen';
import SyosBtnToggleLegend from './SyosBtnToggleLegend';
import type SyosController from './SyosController';
import { Screen } from './api/types';
import type SyosMediaQuery from './utils/SyosMediaQuery';

const Class = {
  SCREEN_DESCRIPTION: 'tn-syos-screen-header__screen-description',
};

const getHtml = () => `
  <div class="tn-syos-screen-header__row-1">
    <div class="${Class.SCREEN_DESCRIPTION}"></div>
    <div class="tn-syos-btn-toggle-full-screen__container"></div>
  </div>
  <div class="tn-syos-screen-header__row-2">
    <div class="tn-syos-btn-view-screens__container"></div>
    <div class="${SyosBtnViewKeyCommands.DesktopContainerClassName}"></div>
    <div class="tn-syos-btn-toggle-legend__container"></div>
  </div>
`;

class SyosScreenHeader extends SyosUiContainer {
  $screenDescription: JQuery<HTMLElement>;

  btnViewKeyboardCommands: SyosBtnViewKeyCommands;

  btnViewScreens: SyosBtnViewScreens;

  fullscreenManager?: SyosFullscreenManager;

  btnToggleFullScreen?: SyosBtnToggleFullScreen;

  btnToggleLegend: SyosBtnToggleLegend;

  constructor(syosController: SyosController, syosMediaQuery: SyosMediaQuery, isDisplayedInAModal: boolean) {
    super(syosController, '.tn-syos-screen-header');

    syosController.on(SyosEvents.SCREEN_UPDATED, this.onScreenUpdated);
    syosController.on(SyosEvents.SEAT_LIST_DATA_LOADED, this.onSeatListDataLoaded);

    this.$el.html(getHtml());

    this.$screenDescription = this.$el.find(`.${Class.SCREEN_DESCRIPTION}`);

    this.btnViewKeyboardCommands = new SyosBtnViewKeyCommands(syosController, `.${SyosBtnViewKeyCommands.DesktopContainerClassName}`);

    this.btnViewScreens = new SyosBtnViewScreens(syosController, syosMediaQuery);

    this.btnToggleLegend = new SyosBtnToggleLegend(syosController, syosMediaQuery);

    if (!isDisplayedInAModal) {
      const fullscreenManager = new SyosFullscreenManager(syosController, syosMediaQuery);

      this.btnToggleFullScreen = new SyosBtnToggleFullScreen(syosController, fullscreenManager);

      if (fullscreenManager.getFullscreenEnabled()) {
        syosController.setFullScreenIsEnabled();
      }

      this.fullscreenManager = fullscreenManager;
    }

    this.$el.hide();
  }

  onScreenUpdated = ({ screen }: { screen: Screen }) => {
    if (screen) {
      this.$screenDescription.text(screen.description);
    } else {
      this.$el.hide();
    }
  };

  onSeatListDataLoaded = () => {
    this.$el.show();
  };

  destroy() {
    this.fullscreenManager?.destroy();
    this.btnViewKeyboardCommands.destroy();
    this.btnViewScreens.destroy();
    this.btnToggleFullScreen?.destroy();
    this.btnToggleLegend.destroy();

    super.destroy();
  }
}

export default SyosScreenHeader;
